import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top on route change
    window.scrollTo(0, 0);

    const header = document.querySelector(".header");
    if (!header) return;

    // ------ INITIAL HEADER PROPERTIES ------
    if (pathname === "/") {
      header.style.backgroundColor = "#b0b0b03e";
      header.style.position = "fixed";
      header.style.color = "";
    } else {
      header.style.backgroundColor = "#E0E0E0";
      header.style.position = "sticky";
      header.style.color = "black";
    }

    let lastScrollTop = 0;

    const handleScroll = () => {
      const scrollY = window.scrollY;

      // ------ NAV LINKS ------
      const headernav = header.querySelector(".nav");
      const headernavLinks = headernav ? headernav.querySelectorAll("a") : [];

      // ------ TOOL ICON LINKS ------
      const headertool = header.querySelector(".tool-icons");
      const headertoolLinks = headertool ? headertool.querySelectorAll("a") : [];

      // ------ BACKGROUND + LINK COLOR CHANGE ------
      if (scrollY > 100) {
        header.style.backgroundColor = "#282828b9";

        headertoolLinks.forEach((link) => {
          link.style.color = "white";
        });

        headernavLinks.forEach((link) => {
          link.style.color = "white";
        });
      } else {
        header.style.backgroundColor =
          pathname === "/" ? "#b0b0b03e" : "#E0E0E0";
    
          


        headernavLinks.forEach((link) => {
          link.style.color = pathname === "/" ? "white" : "black";
        });

        headertoolLinks.forEach((link) => {
          link.style.color = pathname === "/" ? "white" : "black";
        });
      }

      // ------ SHOW / HIDE ON SCROLL ------
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > lastScrollTop) {
        // scrolling down
        header.style.top = "-400px";
      } else {
        // scrolling up
        header.style.top = "0px";
      }

      lastScrollTop = Math.max(scrollTop, 0);
    };

    // Run once immediately
    handleScroll();

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [pathname]);

  return null;
}
